import http from "./http-common";
import authHeader from "./auth-header";
import process from "shelljs";

const API_URL = process.env.BFF_URL;

class FileService {

  uploadFile(mid, file) {
    let formData = new FormData();
    formData.append("file", file)
    return http.post(API_URL + `/v1/merchants/${mid}/files/upload`, formData, {headers: authHeader()});
  }

  uploadBase64File(mid, file) {
    return http.post(API_URL + `/v1/merchants/${mid}/files/upload/base64`, file, {headers: authHeader()});
  }

  deleteFile(mid, fileId) {
    return http.delete(API_URL + `/v1/merchants/${mid}/files/${fileId}`, {headers: authHeader()});
  }

  getFileUrl(mid, fileId) {
    return http.get(API_URL + `/v1/merchants/${mid}/files/${fileId}/url`, {headers: authHeader()});
  }

  getFile(mid, fileId) {
    return http.get(API_URL + `/v1/merchants/${mid}/files/${fileId}/file`, {headers: authHeader()});
  }

  // Customer-scoped file operations
  uploadFileForCustomer(customerId, file) {
    let formData = new FormData();
    formData.append("file", file)
    return http.post(API_URL + `/v1/customers/${customerId}/files/upload`, formData, {headers: authHeader()});
  }

  deleteFileForCustomer(customerId, fileId) {
    return http.delete(API_URL + `/v1/customers/${customerId}/files/${fileId}`, {headers: authHeader()});
  }

  getFileUrlForCustomer(customerId, fileId) {
    return http.get(API_URL + `/v1/customers/${customerId}/files/${fileId}/url`, {headers: authHeader()});
  }

  uploadLogo(mid, file) {
    let formData = new FormData();
    formData.append("file", file)
    formData.append("merchantId", mid)
    return http.post(API_URL + `/merchants/${mid}/v1/files`, formData, {headers: authHeader()});
  }

  fetchLogo(mid) {
    return http.get(API_URL + `/merchants/${mid}/v1/files/${mid + '.png'}`, {headers: authHeader()});
  }

  deleteLogo(mid) {
    return http.delete(API_URL + `/merchants/${mid}/v1/files/${mid + '.png'}`, {headers: authHeader()});
  }

  handleResponse(response) {
    return response
  }
}

export default new FileService();



// WEBPACK FOOTER //
// ./src/service/file.service.js